import React from 'react'
import {Link} from 'react-router-dom'



const S5_home = () => {
  return (
      <section className='S5_home'>
          <div className='container'>
              <div className='row'>
                  <div className='col-lg-6 abs'>
                  <span>Limited Time Offer</span>
                  <h3>Special Edition</h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.</p>
                  <span className='mb-5'>Buy This T-shirt At 20% Discount, Use Code OFF20</span>    
                  <Link className='' to="/Store"> SHOP NOW </Link>  
                      
                      
                  </div>    
   


          
        
      

          </div>
          </div>       
      </section>
  )
}

export default S5_home